import { PageHeader } from "components/ui";
import React from 'react';
import { Grid, Typography, Box } from "@mui/material";
import { fontFamily, fontSize } from '../../../node_modules/@mui/system/index';
import CustomButton from 'components/buttonsComponent/StyledButton';
import NavigationButtons from 'helper/navigation/NavigationButtons';

const WhatisSdg = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <PageHeader
            title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards"
          />
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Box className="gri-header">
          <NavigationButtons imageKey="SDG" title={"SDG Reporting"} activeStep={0} />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box
          sx={{
            borderRadius: '8px',
            padding: '24px',
            top: '226px',
            left: '75px',
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: '#2E7D32',
              mb: 3,
              fontFamily: 'DM Sans',
              fontSize: '40px',
              lineHeight: '38px',
            }}
          >
            The global standards for sustainability<br /> impacts
          </Typography>

          <Box sx={{ mb: 2 }}>
            <Typography
              component="h4"
              sx={{
                fontFamily: 'DM Sans',
                fontWeight: 800,
                fontSize: '20px',
                lineHeight: '28px',
                letterSpacing: '-2%',
                color: '#4F4F4F',
                mb: 1,
              }}
            >
              What is SDG? — Brief introduction
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: 'DM Sans',
                fontWeight: 400,
                fontSize: '20px',
                lineHeight: '28px',
                letterSpacing: '-2%',
                color: '#4F4F4F',
                mb: 2
              }}
            >
              The Sustainable Development Goals (SDGs) are a universal set of 17 goals and 169 targets adopted by all United Nations member states in 2015 as part of the 2030 Agenda for Sustainable Development.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: 'DM Sans',
                fontWeight: 400,
                fontSize: '20px',
                lineHeight: '28px',
                letterSpacing: '-2%',
                color: '#4F4F4F',
                mb: 2
              }}
            >
              These goals provide a comprehensive framework to address the world’s most pressing social, economic, and environmental challenges, aiming to end poverty, fight inequality, protect human rights, promote peace, and safeguard the planet by the year 2030.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: 'DM Sans',
                fontWeight: 400,
                fontSize: '20px',
                lineHeight: '28px',
                letterSpacing: '-2%',
                color: '#4F4F4F',
                mb: 2
              }}
            >
              The SDGs cover diverse themes including quality education, clean water, affordable clean energy, decent work and economic growth, climate action, sustainable cities, biodiversity conservation, responsible production and consumption, and strong institutions.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: 'DM Sans',
                fontWeight: 400,
                fontSize: '20px',
                lineHeight: '28px',
                letterSpacing: '-2%',
                color: '#4F4F4F',
                mb: 2
              }}
            >
              Importantly, the SDGs call on governments, businesses, civil society, and individuals to work in partnership, recognizing that achieving meaningful progress requires collaborative, cross-sectoral efforts across local, national, and global levels.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: 'DM Sans',
                fontWeight: 400,
                fontSize: '20px',
                lineHeight: '28px',
                letterSpacing: '-2%',
                color: '#4F4F4F'
              }}
            >
              The SDGs are also closely linked to other global initiatives, such as the Paris Agreement on Climate Change, ensuring that sustainability, resilience, and inclusion remain at the heart of development and decision-making processes worldwide.
            </Typography>
          </Box>

        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <a
            href="https://sdgs.un.org/goals"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <CustomButton title="Access to full SDG Disclosure" />
          </a>
        </Box>
      </Grid>
    </Grid>
  );
};

export default WhatisSdg;